Ext.define('SA.view.sidebar.data.ImportsDataSearchWindow', {
    alias: 'widget.imports-data-search-window',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-imports-data-search-window',
    floating: true,
    plugins: ['sa-arrow', 'close-on-click-outside'],

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-imports-data-search-window-header',

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-imports-data-search-window-header-content',

                    items: [
                        {
                            xtype: 'result-count-message'
                        }, {
                            xtype: 'condition',
                            itemId: 'sidebarSearchCondition'
                        }, {
                            xtype: 'condition',
                            itemId: 'windowSearchCondition'
                        }
                    ]
                }, {
                    xtype: 'close-button',
                    closeAction: 'hide'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-imports-data-search-window-body',

            items: [
                {
                    xtype: 'sa-text-field',
                    clearButton: true,
                    cls: 'sa-imports-data-search-window-search-field',
                    emptyText: 'Filter',
                    icon: true,
                    ui: 'compact'
                }, {
                    xtype: 'imports-search-result-list',
                    cls: 'sa-imports-data-search-window-result-list'
                }, {
                    xtype: 'no-results-message',
                    cls: 'sa-imports-data-search-window-no-results-message',
                    text: 'No results found. Please adjust your search parameters.'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-imports-data-search-window-footer'
        }
    ],

    initComponent() {
        this.callParent();

        this.resultCountMessage = this.down('result-count-message');
        this.sidebarSearchCondition = this.down('#sidebarSearchCondition');
        this.windowSearchCondition = this.down('#windowSearchCondition');
        this.searchField = this.down('sa-text-field');
        this.resultList = this.down('imports-search-result-list');
        this.noResultsMessage = this.down('no-results-message');
    },

    buildResultComponents() {
        var project = SA.AppController.getCurrentProject(),
            datasets = SA.data.UserDatasets.getDatasetsForCountry(project.getCountry()),
            getAttributes = dataset => SA.data.UserAttributes.getForDataset(dataset),
            isSelected = attribute => project.getAttributes().includes(attribute);

        this.resultList.setItems(datasets.map(dataset => ({
            xtype: 'dataset-attribute-list',
            cls: 'sa-imports-data-search-window-dataset-attribute-list',
            name: dataset.name,

            attributes: getAttributes(dataset.id).map(({attribute, name}) => ({
                xtype: 'attribute',
                attribute,
                name,
                selected: isSelected(attribute),

                listeners: {
                    'select': this.onAttributeSelected,
                    scope: this
                }
            }))
        })));
    },

    clearSearchField() {
        this.searchField.clear();
    },

    initEvents() {
        this.callParent();

        SA.Viewport.on('resize', this.refreshHeight, this);

        this.sidebarSearchCondition.on('click:remove', this.onSidebarSearchConditionRemoveClick, this);
        this.windowSearchCondition.on('click:remove', this.onWindowSearchConditionRemoveClick, this);

        this.searchField.on('change', this.onChangeSearchField, this, {buffer: 250});
        this.searchField.on('clear', this.onChangeSearchField, this);
    },

    onAttributeSelected(attribute) {
        this.fireEvent('select:attribute', this, attribute);
    },

    onChangeSearchField() {
        this.windowSearchCondition.setText(this.searchField.getValue().trim());
        this.refreshResults();
    },

    onSidebarSearchConditionRemoveClick() {
        this.sidebarSearchCondition.clear();
        this.refreshResults();

        this.fireEvent('remove:sidebarSearch');
    },

    onWindowSearchConditionRemoveClick() {
        this.clearSearchField();
        this.refreshResults();
    },

    refreshHeight() {
        this.setHeight(Math.max(300, Ext.dom.Element.getViewportHeight() - 100));
    },

    refreshResults() {
        var conditions = [this.sidebarSearchCondition, this.windowSearchCondition],
            hasConditions = conditions.some(condition => condition.notEmpty()),
            searches = conditions.map(condition => condition.getText().toLowerCase()),
            filter = attribute => searches.every(search => attribute.toLowerCase().includes(search)),
            getCount = () => this.resultList.getFilteredCount();

        this.resultList.setFilter(filter);
        this.resultCountMessage.refresh({hasConditions, count: getCount()});
        this.noResultsMessage.setVisible(!getCount());
    },

    setArrowTarget(target) {
        this.getPlugin('sa-arrow').setTarget(target);
    },

    setSidebarSearch(search) {
        this.sidebarSearchCondition.setText(search);
        this.clearSearchField();

        this.buildResultComponents();
        this.refreshResults();
    },

    showAt(x, y) {
        this.show();
        this.setPagePosition(x, y);
        this.refreshHeight();
    }
});